import { styled } from '@linaria/react';

export const RedText = styled.span`
	color: var(--color-red-50-solid);
`;
